import { useEffect } from "react";

type Listener = (locked: boolean) => void;

let lockCount = 0;
const listeners = new Set<Listener>();

function emit() {
  const locked = lockCount > 0;
  listeners.forEach((listener) => listener(locked));
}

/** Sarah FAB/teaser subscribe: true while any sidebar drawer holds a lock. */
export function subscribeSarahOverlayLock(listener: Listener) {
  listeners.add(listener);
  listener(lockCount > 0);
  return () => {
    listeners.delete(listener);
  };
}

/** Hide Sarah while this overlay (right/left Drawer) is open. */
export function useSarahOverlayLock(active: boolean) {
  useEffect(() => {
    if (!active) return;
    lockCount += 1;
    emit();
    return () => {
      lockCount = Math.max(0, lockCount - 1);
      emit();
    };
  }, [active]);
}
